export default __webpack_public_path__ + "static/jewish-b-1a07fcd98331a1ea6a4b5608076f2e97.png";